import { StateManager } from "./model/utils/StateManager";

export const stateManager = new StateManager();
